import { Inject, Injectable } from '@angular/core';
import { API_URL, UserDetails } from '@frontend-site/shared/data';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { Recommendation } from '../models/recommendation';
import { TranslateService } from '@ngx-translate/core';
import { SessionRepository } from '@frontend-site/shared/core';
import { UserService } from '@frontend-site/users/domain';

@Injectable({ providedIn: 'root' })
export class RecommendationDataService {
    private readonly language = this.session.applicationConfig?.language;

    constructor(
        @Inject(API_URL) private readonly apiUrl: string,
        private http: HttpClient,
        private $translate: TranslateService,
        private readonly session: SessionRepository,
        private user: UserService
    ) {}

    getDataRecommendations(): Observable<[UserDetails, Recommendation[]]> {
        return forkJoin([this.user.getUserDetails(), this.getRecommendations(this.language)]);
    }

    private getRecommendations(language: string | undefined): Observable<Recommendation[]> {
        return this.http.get<Recommendation[]>(`${this.apiUrl}/pqm/getRecommendations/?locale=${language}`);
    }
}
